import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  number: 1,
  title: 'Gift Card $6.000 ARS JumpBox',
  subtitle: 'Tu Primer Paso Físico — Gratis',
  desc: 'Usala en cualquier producto físico JumpBox: Gel de Recuperación, Spray K.O. o Plantillas de Fibra de Carbono.',
  value: '$6.000',
  image: 'https://cdn.magicpatterns.com/uploads/j9Ew8fYsQCrTdFMDk2KMNc/EBOOK_TAREJETA_2.png'
}, {
  number: 2,
  title: 'Ebook "Mentalidad de Acero"',
  subtitle: 'El protocolo mental anti-abandono',
  desc: '5 herramientas mentales de alto rendimiento para no abandonar en la semana 2. Sin esto, el 60% de los protocolos se abandonan.',
  value: '$12.000',
  image: 'https://cdn.magicpatterns.com/uploads/bQAbEnmg1vpeKi6DpDAwXA/ebook_mentalidad_negro.png'
}, {
  number: 3,
  title: 'Guía de Calzado Inteligente',
  subtitle: 'Zapatillas que potencian tu recuperación',
  desc: 'Qué buscar en una zapatilla según tu deporte, pisada y presupuesto. La diferencia entre mantener el resultado o volver al punto cero.',
  value: '$8.000',
  image: 'https://cdn.magicpatterns.com/uploads/9igs3WvFe3pphDBUA69Mwh/EBOOK_GUIA_DEL_CALZADO_.webp'
}];
export function BonusSection() {
  return <section className="py-6 md:py-10 px-4" data-id="element-26">
      <div className="max-w-4xl mx-auto" data-id="element-27">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl md:text-2xl font-black uppercase text-white text-center mb-4" data-id="element-28">
          Bonus <span className="text-neon" data-id="element-29">Exclusivos</span>
        </motion.h2>

        <div className="space-y-3" data-id="element-30">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-dark-card border border-neon/15 rounded-xl p-4 flex gap-4 items-center" data-id="element-31">
              <div className="w-20 shrink-0" data-id="element-32">
                <img src={b.image} alt={b.title} loading="lazy" decoding="async" className="w-full h-auto rounded-lg" data-id="element-33" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-34">
                <span className="text-neon font-bold text-xs uppercase tracking-widest" data-id="element-35">
                  🎁 Bonus #{b.number}
                </span>
                <h3 className="text-base md:text-lg font-black text-white" data-id="element-36">
                  {b.title}
                </h3>
                <p className="text-neon text-base italic mb-1" data-id="element-37">{b.subtitle}</p>
                <p className="text-white text-base leading-relaxed" data-id="element-38">{b.desc}</p>
                <div className="mt-2" data-id="element-39">
                  <span className="text-white/50 line-through text-base mr-1" data-id="element-40">
                    {b.value}
                  </span>
                  <span className="text-neon font-bold text-base" data-id="element-41">GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}